import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './style-new.css';

import {
  FaHome,
  FaPlus,
  FaFolderOpen,
  FaArrowLeft,
  FaFutbol,
  FaTrash,
  FaSignOutAlt,
} from "react-icons/fa";

import { MdCancel } from "react-icons/md";

const AddMember = () => {
  const { id: groupId } = useParams();
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [statusSuccess, setStatusSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showInvitePrompt, setShowInvitePrompt] = useState(false);
  const [showEmailField, setShowEmailField] = useState(false);

  // Accept any common phone format — final normalization happens on the backend.
  // Just make sure there are enough digits to be a real number.
  const isValidPhoneNumber = (number) => {
    const digitCount = number.replace(/[^\d]/g, '').length;
    return digitCount >= 9 && digitCount <= 15;
  };

  const [memberAdded, setMemberAdded] = useState(false);

  const addMember = async (groupId, mobile, email) => {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('User not authenticated');

    const response = await fetch(`/api/groups/${groupId}/members`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ mobile, email }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Failed to add member');
    return data;
  };

  const handleAddMember = async () => {
    const trimmedPhone = phoneNumber.trim();
    const trimmedEmail = email.trim();

    // Validate
    if (!showEmailField && (!trimmedPhone || !isValidPhoneNumber(trimmedPhone))) {
      setStatusMessage('Please enter a valid mobile number.');
      setStatusSuccess(false);
      return;
    }

    if (showEmailField && !trimmedEmail) {
      setStatusMessage('Please enter an email address.');
      setStatusSuccess(false);
      return;
    }

    setLoading(true);
    setStatusMessage('');
    setStatusSuccess(null);

    try {
      const result = await addMember(groupId, trimmedPhone, trimmedEmail);

      if (result.success === false && result.userExists === false) {
        setShowInvitePrompt(true);
        setLoading(false);
        return;
      }

if (result.invited) {
  setStatusMessage('Invitation sent!');
  setStatusSuccess(true);
  setMemberAdded(true);
  resetForm();

//  setTimeout(() => {
//    navigate(-1); // Go back after 2 seconds
//  }, 2000);

  setLoading(false);
  return;
}

      if (result.added) {
        setStatusMessage('User added to group!');
        setStatusSuccess(true);
        setMemberAdded(true);
        resetForm();

//        setTimeout(() => {
//          navigate(-1); // Go back after 2 seconds
//        }, 2000);
      } else {
        setStatusMessage('Operation completed.');
        setStatusSuccess(true);
      }
    } catch (error) {
      setStatusMessage(error.message || 'Error adding member.');
      setStatusSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setPhoneNumber('');
    setEmail('');
    setShowInvitePrompt(false);
    setShowEmailField(false);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleInviteOk = () => {
    setShowInvitePrompt(false);
    setShowEmailField(true);
  };

  return (
    <div className="add-member-form">
      <h3>Add Member</h3>

      {!showEmailField && (
        <input
          type="tel"
          className="input-narrow"
          placeholder="Mobile e.g. 082 123 4567 or +44 7911 123456"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      )}

      {showEmailField && (
        <input
          type="email"
          className="input-narrow"
          placeholder="Please enter the user's email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      )}

{!showInvitePrompt && !showEmailField && (
  <div className="button-group">
    <button
      className="btn btn-primary"
      onClick={handleAddMember}
      disabled={loading}
    >
    <FaPlus />
      {loading ? 'Adding...' : 'Add'}
    </button>

    <button
      className="btn btn-cancel"
      onClick={memberAdded ? () => navigate(-1) : handleCancel}
      disabled={loading}
    >
      <MdCancel />
      {memberAdded ? 'Back' : 'Cancel'}
    </button>
  </div>
)}

{showInvitePrompt && (
  <div className="button-group">
    <p>User does not exist. Do you want to invite them?</p>

    <button
      className="btn btn-primary"
      onClick={handleInviteOk}
      disabled={loading}
    >
      Ok
    </button>

    <button
      className="btn btn-cancel"
      onClick={memberAdded ? () => navigate(-1) : handleCancel}
      disabled={loading}
    >
      <FaArrowLeft />
      {memberAdded ? 'Back' : 'Cancel'}
    </button>
  </div>
)}

{showEmailField && (
  <div className="button-group">
    <button
      className="btn btn-primary"
      onClick={handleAddMember}
      disabled={loading}
    >
      {loading ? 'Sending...' : 'Send Invite'}
    </button>

    <button
      className="btn btn-cancel"
      onClick={memberAdded ? () => navigate(-1) : handleCancel}
      disabled={loading}
    >
      <FaArrowLeft />
      {memberAdded ? 'Back' : 'Cancel'}
    </button>
  </div>
)}

      {statusMessage && (
        <p style={{ color: statusSuccess ? 'green' : 'red', marginTop: '10px' }}>
          {statusMessage}
        </p>
      )}
    </div>
  );
};

export default AddMember;
